var dataLayer = window.dataLayer || [];
var $ = $ || {};

$(document).ready(function(){
    $('#sort_lenders').change(function(event){
        var tableSorted = $('.comparison-table-button.active').attr('id');
        var sortedBy = $(this).find(':selected').data('sortby');
        var eventObj = {
            'event': 'userSortedLenders',
            'eventData':{
                'tableSorted': tableSorted,
                'sortedBy': sortedBy
            }
        }
        window.dataLayer.push(eventObj);
    });
});

$(document).on("lenderAdded", function(event,data){
    var obj = {
        "event": "lenderAdded",
        "lenderAdded": data.lender
    }
    dataLayer.push(obj);
});

$(document).on("lenderRemoved", function(event,data){
    var obj = {
        "event": "lenderRemoved",
        "lenderRemoved": data.lender
    }
    dataLayer.push(obj);
});

$(document).on("lendersCurrentlyLoaded", function(event,data){
    var obj = {
        "event": "lendersLoaded",
        "lendersLoaded": {
            'lenders': data.lenders.join(","),
            'lendersCount': data.lendersCount
        }
    }
    dataLayer.push(obj);
});

$(document).on("tabSwitch", function(event,data){
    var obj = {
        "event": "tabSwitch",
        "tabSwitch": data.tabType
    }
    dataLayer.push(obj);
});

